import axios from 'axios'

export function useAsyncRequest() {
    const loading = ref(false)
    const error = ref(null)
    const controller = ref(null)

    onBeforeUnmount(() => {
        controller.value?.abort()
    })

    const request = async (method, url, params = {}, config = {}) => {
        controller.value?.abort()
        controller.value = new AbortController()

        loading.value = true
        error.value = null

        try {
            const response = await axios({
                method,
                url,
                ...(method.toLowerCase() === 'get' ? { params } : { data: params }),
                ...config,
                signal: controller.value.signal
            })

            return response.data
        } catch (e) {
            if (e.code === 'ERR_CANCELED') return
            error.value = e
            throw e
        } finally {
            loading.value = false
        }
    }

    return {
        loading,
        error,
        request,
        get: (url, params = {}, config = {}) => request('GET', url, params, config),
        post: (url, data = {}, config = {}) => request('POST', url, data, config),
        put: (url, data = {}, config = {}) => request('PUT', url, data, config),
        del: (url, data = {}, config = {}) => request('DELETE', url, data, config)
    }
}
